var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameterminology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 61,
    viewBox: "0 0 99 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4276 35.3447V47.8765H1.57324V2.02832H83.4276V12.8179",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0945 17.4333V58.9718H12.2402V49.0075",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 18.1362H48.2164",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 31.7683H60.4426",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6771 36.8729L72.0576 41.366L72.2716 31.5545C72.2716 30.9126 72.4855 30.2708 72.8218 29.7206L87.7377 6.27687C88.2267 5.48216 89.1131 5.02368 90.0301 5.02368H93.3617C94.4315 5.02368 95.4096 5.66556 95.8681 6.64365L97.1519 9.54737C97.5187 10.3726 97.4575 11.3507 96.9685 12.1149L82.022 35.6197C81.6857 36.1393 81.2273 36.5672 80.6465 36.8729H80.6771Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3398 6.09351L79.1182 30.0263",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2576 35.742L80.0044 32.5632C79.4236 31.1266 78.0176 30.2402 76.4893 30.3013L73.0049 30.4847",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameterminology);
export default __webpack_public_path__ + "static/media/Frameterminology.6f304f8e85d497d04f32213db48a94aa.svg";
export { ForwardRef as ReactComponent };